/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from "react"
import { User } from "../types"

export const UserContext = createContext<{
	user: false | User | undefined
	updateUser: (patch: Partial<User>) => void
}>({
	user: { _id: "", avatar: "", commentCount: 0, name: "" },
	updateUser: () => {},
})
